import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import PlanTeam from '../components/PlanTeam'
import Textbox from '../components/Textbox'

const PlanTeamMembers = ({ plans, teams, users, user }) => (
  teams[plans.selectedTeamId]?
    <div>
      <PlanTeam teamId={plans.selectedTeamId} />
      {teams[plans.selectedTeamId] && teams[plans.selectedTeamId].members?
        teams[plans.selectedTeamId].members.map(uid => {
          return (
            <Textbox 
              subtitle = {users[uid].realName + (users[uid].nickName? ' (' + users[uid].nickName + ')' : '')}
              subtitleImage = {users[uid].images ? users[uid].images.x48 : null}
              text = {plans.planData[plans.selectedPlanId][uid] && plans.planData[plans.selectedPlanId][uid].plan !== '' ? 
                  plans.planData[plans.selectedPlanId][uid].plan
                :
                  ' '
                }
              editable = {uid === user.uid}
              editLink = '/plan/edit'
              key = {uid}
            />
          )
        })
      :
        null
      }
    </div>
  :
    <Redirect to='/plan' />
)

export default connect(
  state => ({
    teams: state.organization.teams,
    plans: state.plans,
    users: state.users,
    user: state.user
  })
)(PlanTeamMembers)



// WEBPACK FOOTER //
// ./src/components/PlanTeamMembers.js